<template>
  <div class="circular-progress-wrap">
    <div class="progress-container">
      <div class="progress-circular-mark">
        <div class="progress-tick-wrap">
          <span
            class="tick"
            v-for="item of ticks"
            :key="item.angle"
            :class="{'actived': item.isActive}"
            :style="{ transform: `rotate(${ item.angle }deg) translateY(-${ offset }px)` }"
          ></span>
        </div>
        <div class="progress-msg-circular-mark">
          <div class="progress-msg">
            <p class="percents">{{ `${ percents }%` }}</p>
            <p class="tis">项目进度</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    percents: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ticks: [],
      offset: 0, // 偏移量
      activedIndexAngle: null, // 最后终止的刻度角度
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    percents(val) {
      // console.log(val, 111)
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.ticks = []

      const angle = 216 // 这里是分216度
      const tickNum = 42 // 刻度的条数
      const tickAngle = Math.floor( angle / tickNum )// 每一个刻度递增的角度

      // 获取已经达到的刻度的索引，用完成任务的百分比来除以（100 / 42(刻度的条数)），向下取整
      const activedIndex = Math.floor(this.percents / (100 / tickNum))

      // 获取已达到的刻度的角度值，由于是从-108度开始计算的，所以得减去108
      // 由于这里递增的角度是有偏差的，所以得将百分百 或者 0 的情况特殊处理下
      this.activedIndexAngle = this.percents === 100
        ? 108
        : this.percents === 0
        ? -109
        : (activedIndex * tickAngle).toFixed(2) - 108
      // console.log(activedIndex, tickAngle, this.activedIndexAngle, 11)

      for (let i = -108; i <= 108; i += tickAngle) {
        const angle = i // 刻度的角度
        const isActive = Number(i.toFixed(2)) <= this.activedIndexAngle
        // console.log(i.toFixed(2),  activedIndexAngle)
        this.ticks.push({ angle, isActive })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.circular-progress-wrap {
  position: relative;
  width: 132px;
  height: 88px;
  .progress-container {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 66px 66px 0 0;
    overflow: hidden;
    .progress-circular-mark {
      width: 132px;
      height: 132px;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      left: 0;
      top: 0;
    }
    .progress-tick-wrap {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform-origin: center center;
      &::before {
        content: "";
        background: linear-gradient(to right, #ff0000, #00ff00); /* 刻度的渐变颜色 */
      }
      .tick {
        position: absolute;
        left: 50%;
        top: -22px;
        display: block;
        width: 2px;
        height: 88px;
        transform-origin: bottom center;
        @include bgColorOpacity(.16);
        &.actived {
          background: #2682FF;
        }
      }
    }
    .progress-msg-circular-mark {
      width: 102px;
      height: 102px;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      left: 15px;
      top: 15px;
    }
    .progress-msg {
      // position: absolute;
      // left: 0;
      // top: 0;
      width: 102px;
      height: 73px;
      border-radius: 73px 73px 0 0;
      background: #fff;
      padding-top: 20px;
      box-sizing: border-box;
      p {
        text-align: center;
        &.percents {
          font-size: 20px;
          font-weight: bold;
          @include fontColorOpacity(1);
          line-height: 20px;
          margin-bottom: 8px;
        }
        &.tis {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          @include fontColorOpacity(.6);
          line-height: 20px;
        }
      }
    }
  }
}
</style>
